import { render } from "./cp_popMark.vue?vue&type=template&id=5ad74925&scoped=true"
import script from "./cp_popMark.vue?vue&type=script&lang=js"
export * from "./cp_popMark.vue?vue&type=script&lang=js"

import "./cp_popMark.vue?vue&type=style&index=0&id=5ad74925&scoped=scoped&lang=less"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad74925"]])

export default __exports__